import { useCallback } from 'react';
import billingClient, {
  type Enterprises
} from '../utils/billing-client/client-v1';
import useAPI from './useAPI';

interface UseAllEnterprisesProps {
  token: string;
}

interface UseAllEnterprisesResponse {
  loading: boolean;
  error: Error | null;
  data: Enterprises.SimpleEnterprise[] | null;
  refresh: () => void;
}

export const useAllEnterprises = ({
  token
}: UseAllEnterprisesProps): UseAllEnterprisesResponse => {
  const dataLoader = useCallback(() => {
    return billingClient.enterprises.listSimple({ token });
  }, [token]);
  const state = useAPI(dataLoader);
  return {
    loading: state.loading,
    error: state.error,
    data: state.data,
    refresh: state.refresh
  };
};
